import { MuiTheme } from "theme";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Breakpoints from "common/breakpoints";

export default makeStyles((theme: MuiTheme) => ({
  tableContainer: {
    position: "relative",
    borderBottom: "1px solid #eeeeee",
    flexGrow: 1,
    [theme.breakpoints.up(Breakpoints.SX_720)]: {
      flex: "auto"
    }
  },
  slideLoader: {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0
  },
  emptyDataHolder: {
    flexGrow: 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#c3c3c3",
    borderBottom: "1px solid #eeeeee",
    fontSize: 14
  },
  classicView: {
    fontSize: 12,
    marginTop: 8,
    alignItems: "center",
    "& .MuiSvgIcon-root": {
      fontSize: 14,
      width: 14,
      height: 14,
      lineHeight: 1,
      marginLeft: 4
    }
  },
  accordion: {
    "& .MuiCollapse-container": {
      padding: 8,
      margin: -8
    },
    paddingBottom: 10
  },
  loader: {
    flex: "auto"
  },
  loaderCell: {
    height: 84
  },
  lifetimeStatsCell: {
    [theme.breakpoints.down(Breakpoints.SX_720)]: {
      paddingTop: 13,
      paddingBottom: 13
    }
  },
  lifetimeStats: {
    fontSize: 13,
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular"
  },
  lifetimeStatsTitle: {
    minWidth: 40
  }
}));
